import { makeObservable, action, observable } from "mobx";
class TabStore {
  paymentMethods = ["banklinks"];
  currentTab = this.getInitialTabName();
  constructor() {
    makeObservable(this, {
      paymentMethods: observable,
      currentTab: observable,
      setCurrentTab: action,
      initializePaymentMethods: action
    });
  }
  setCurrentTab(tabName) {
    this.currentTab = tabName;
  }
  initializePaymentMethods(paymentMethods) {
    if (!paymentMethods || paymentMethods.length == 0) {
      return;
    }
    if (!TabStore.paymentMethodsValidation(paymentMethods)) {
      throw Error();
    }
    this.paymentMethods = [...new Set(paymentMethods)];
    if (paymentMethods[0] === "card") {
      this.setCurrentTab("payment-card-tab");
    }
  }
  getInitialTabName() {
    switch (this.paymentMethods[0]) {
      case "banklinks":
        return "payment-banklink-tab";
      case "card":
        return "payment-card-tab";
      default:
        return "payment-banklink-tab";
    }
  }
  static paymentMethodsValidation(paymentMethods) {
    const supportedPaymentMethods = ["banklinks", "card"];
    return paymentMethods.every((method) => supportedPaymentMethods.includes(method));
  }
}
export {
  TabStore as default
};
